import { useState } from 'react';
import PropTypes from 'prop-types';
import t from './utils/i18n.js';
import GoogleMap from './Map.jsx';

const SchoolCard = (props) => {
    const [mapOverlayOpen, setMapOverlayOpen] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState({
        id: '',
        schoolname: '',
        url: '',
        c: [],
        teaser: ''
    });
    const [selectedTab, setSelectedTab] = useState('info');

    const openMap = (school) => {
        setMapOverlayOpen(true);
        setSelectedSchool(school);
        const mapElement = document.getElementById('map-wrapper');
        document.getElementById('list-map').appendChild(mapElement);
        mapElement.dispatchEvent(new CustomEvent('openmap', { detail: { 'schoolId': school.id }}));
    };

    const closeMap = () => {
        setMapOverlayOpen(false);
        const mapElement = document.getElementById('map-wrapper');
        document.getElementById('filter-map').appendChild(mapElement);
        mapElement.dispatchEvent(new CustomEvent('closemap'));
    };

    const lang = props.lang;

    const schoolContent = props.schools.map((school, index) => {
        return (
            <a className="card__item map__list-item" data-school-id={school.id} href={school.url} key={index}>
                <div className="card__text">
                    <h2>{school.schoolname}</h2>
                    <div className="map__text">{school.county}</div>
                    <div className="map__slogan">{school.slogan}</div>
                </div>
                <div className="card__icons">
                    <ul className="card__list-icons">
                        <li className="card__list-icon">
                            {school.christian ?
                                <span className="card__icon-count card__list-icons__religion">{t('Kristen', lang)}</span>
                            : <span className="card__icon-count card__list-icons__religion">{t('Frilynt', lang)}</span> }
                        </li>
                        <li className="card__list-icon">
                            <img src={"/resources/images/pol-elever.svg"} alt="elever" />
                            <span className="card__icon-count">{school.students}</span>
                        </li>
                        <li className="card__list-icon">
                            <img src={"/resources/images/pol-linjer.svg"} alt="linjer" className="card__icon-courses" />
                            <span className="card__icon-count">{school.courses}</span>
                        </li>
                        <li className="card__list-icon" onClick={(e) => { e.preventDefault(); openMap(school); }}>
                            <img src={"/resources/images/pol-kart.svg"} alt="kart" className="card__icon-map" />
                            <span className="card__icon-count">{t('Vis i kart', lang)}</span>
                        </li>
                    </ul>
                </div>
                <div className="card__image">
                    <img src={school.i} alt=""/>
                </div>
            </a>
        )
    });

    const courses = [];
    for (const course of selectedSchool.c) {
        courses.push(
            <li className="map__list-tab-item" key={course.u}>
                <a className="map__list-tab-link" href={selectedSchool.url + '/' + course.u} target="_blank">{course.t}</a>
            </li>
        )
    }

    return (
        <div>
            <div className="card__wrapper">
                {schoolContent}
            </div>
            <div className={'map__info-window' + (mapOverlayOpen ? ' map__info-window--active' : '')}>
                <div className="map__info-content">
                    <button className="map__close" onClick={(e) => { e.preventDefault(); closeMap()}}></button>
                    <div className="map__list-content-extra">
                        <div className="map__list-map" id="list-map"></div>
                        <div className="map__list-tab-control">
                            <button className={'button button--' + (selectedTab == 'info' ? 'primary' : 'secondary') + ' map__list-tab-button'}
                                    onClick={() => setSelectedTab('info')}>{t("Intro", lang)}</button>
                            <button className={'button button--' + (selectedTab == 'courses' ? 'primary' : 'secondary') + ' map__list-tab-button'}
                                    onClick={() => setSelectedTab('courses')}>{t("Linjer", lang)}</button>
                        </div>
                        <div className={'map__list-tab' + (selectedTab == 'info' ? ' active' : '')}>
                            <h2>{t("Intro", lang)}</h2>
                            <div className="map__list-tab-content">{selectedSchool.teaser}</div>
                        </div>
                        <div className={'map__list-tab' + (selectedTab == 'courses' ? ' active' : '')}>
                            <h2>{t("Linjer", lang)}</h2>
                            <ul>
                                {courses}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

SchoolCard.propTypes = {
    schools: PropTypes.array.isRequired,
};

export default SchoolCard;
